<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="昵称：" prop="nick_name">
                <span>{{model.nick_name}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="mail">
                <span>{{model.mail}}</span>
            </el-form-item>
            <el-form-item label="车型：" prop="car_type">
                <span>{{model.car_type}}</span>
            </el-form-item>
            <el-form-item label="IP地址：" prop="ip_add">
                <span>{{model.ip_add}}</span>
            </el-form-item>
            <el-form-item label="省份：" prop="province">
                <span>{{model.province}}</span>
            </el-form-item>
            <el-form-item label="发布时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="动态类型：" prop="moment_type">
                <span>{{model.moment_type}}</span>
            </el-form-item>
            <el-form-item label="动态内容：" prop="content">
                <span>{{model.content}}</span>
            </el-form-item>
            <el-form-item label="文章内容：" prop="content_txt">
                <span>{{model.content_txt}}</span>
            </el-form-item>
            <el-form-item label="图片：" prop="imgs">
                <span>{{model.imgs}}</span>
            </el-form-item>
            <el-form-item label="浏览量：" prop="view_count">
                <span>{{model.view_count}}</span>
            </el-form-item>
            <el-form-item label="点赞量：" prop="like_count">
                <span>{{model.like_count}}</span>
            </el-form-item>
            <el-form-item label="审核状态：" prop="sh_state">
                <span>{{model.sh_state}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'momentInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                mail: '',
                is_auth: '',
                car_type: '',
                face: '',
                ip_add: '',
                province: '',
                add_time: '',
                moment_type: '',
                content: '',
                content_txt: '',
                imgs: '',
                view_count: '',
                like_count: '',
                sh_state: '',
                is_del: '',
            },
            getObj:{
                url:'/api/admin/moment/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>